<template>
  <div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label>มูลค่างานตามสัญญา
           <!-- <span class="text-white">N-SCG_7</span> -->
          </label>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-6">
        <label>มูลค่างาน(บาท)</label>
        <vue-numeric
          separator=","
          v-bind:precision="2"
          v-model="jobPrice"
          name="jobPrice"
          class="form-control"
          placeholder="กรุณากรอกจำนวน"
          data-vv-as="มูลค่างาน"
          
          v-validate="{ max_value:checkMiddlePrice }"
          :class="{'input': true, 'is-danger': errors.has('jobPrice') }"
        ></vue-numeric>
        <span
        v-show="errors.has('jobPrice')"
        class="help is-danger"
        >{{ errors.first('jobPrice') }}</span> 

      </div>
      <div class="form-group col-md-6">
        <label>ราคากลาง(บาท)</label>
        <vue-numeric
          separator=","
          v-bind:precision="2"
          v-model="middlePrice"
          name="middlePrice"
          class="form-control"
          placeholder="กรุณากรอกจำนวน"
          data-vv-as="ราคากลาง"
          
          :class="{'input': true, 'is-danger': errors.has('middlePrice') }"
        ></vue-numeric>

        <span
        v-show="errors.has('middlePrice')"
        class="help is-danger"
        >{{ errors.first('jobPrice') }}</span> 
      </div>
    </div>
  </div>
</template>

<script>

export default {
  inject: ['$validator'],
  props: ["reqType","appVo"],
  data() {
    return {
      jobPrice: this.appVo.jobPrice,
      middlePrice: this.appVo.middlePrice,
      // reqType:this.reqType,
    };
  },
  mounted() {
    // initial ค่ากรณีที่เป็น ต่ออายุและ เพิ่มวงเงิน

    if(this.appVo){
      this.jobPrice = this.appVo.jobPrice;
      this.middlePrice = this.appVo.middlePrice;

      this.$emit("childExtToParent", {
        jobPrice: this.jobPrice,
        middlePrice: this.middlePrice
      });
    }
  },    
  computed: {

    checkMiddlePrice: function() {
      if(this.middlePrice!==null&&this.middlePrice>0){
        return this.middlePrice
      }else{
        return 1000000000000;
      }
    },
  },
  created() {
  },  
  watch: {
    jobPrice(newVal, oldVal) {
      this.$emit("childExtToParent", {
        jobPrice: this.jobPrice,
        middlePrice: this.middlePrice
      });
    },
    middlePrice(newVal, oldVal) {
      this.$emit("childExtToParent", {
        jobPrice: this.jobPrice,
        middlePrice: this.middlePrice
      });
    }
  }
};
</script>